import { useEntriesV2 } from "@/Hooks"
import { useEffect, useImperativeHandle, useRef, useState } from "react"
import { useParams } from "react-router-dom"
import { disableDirectTunnelMessage } from "../store/states"

export const useDirectTunnelSettings = (ref, data) => {
	const { id } = useParams()
	const postRef = useRef()
	const [directTunnelStatus, { getData: getDirectTunnelStatus }] = useEntriesV2(`/api/v2/device/configure/directTunnel/${id}`)
	const [directTunnelServiceStatus, { getData: getDirectTunnelServiceStatus }] = useEntriesV2(`/api/v2/device/directTunnel/${id}/status`)
	const [dimmerDirectTunnel, setDimmerDirectTunnel] = useState({
		isDimmed: false,
		dimmerMessage: null
	})

	const fetchSubnetMappingRef = useRef()

	/** Refresh the entire settings page */
	const refreshServiceStatus = (resetFlag) => {
		if (data.type === "AA") return
		/* use ref to lift up the fetch method from each of child component */
		resetFlag && postRef.current.resetPost()
		getDirectTunnelStatus()
		getDirectTunnelServiceStatus()
		fetchSubnetMappingRef.current.getDirectTunnelSubnetMapping() // refresh the subnet mappings
	}

	const handleDimmerDirectTunnel = (dimmerMessage) => {
		if (dimmerMessage) {
			setDimmerDirectTunnel({ isDimmed: true, dimmerMessage: dimmerMessage })
		} else {
			setDimmerDirectTunnel({ isDimmed: false, dimmerMessage: null })
			refreshServiceStatus()
		}
	}


	useImperativeHandle(ref, () => ({
		refreshServiceStatus: refreshServiceStatus
	}))

	useEffect(() => {
		if (data.type === "AA") handleDimmerDirectTunnel(disableDirectTunnelMessage.AA_DEVICE)
	}, [])

	useEffect(() => {
		if (data.type === "AA") return
		getDirectTunnelStatus()
		getDirectTunnelServiceStatus()
	}, [])

	return { directTunnelStatus, directTunnelServiceStatus, refreshServiceStatus, dimmerDirectTunnel, handleDimmerDirectTunnel, fetchSubnetMappingRef, postRef }
}
